<div class="message-card">
  <div class="error-icon">
    <img ngSrc="/utest-static/assets/images/registration/warning.svg" alt="" height="40" width="40"/>
  </div>

  <h1 class="title">This Link Has Expired</h1>

  <div class="message-body">
    <p>To keep your account secured, we can't verify your email address using an expired link.</p>
    <p>
      We are sending a new email with all the details you need.
    </p>
    <p>Please check your inbox in a few moments, and follow the instructions.</p>
  </div>

  <div class="message-body new-link-notice">
    <p>The new link will remain active for 15 minutes.</p>
  </div>

  <div class="message-body new-link-notice">
    <p>Did not receive the email?</p>
    <p>Make sure to also look at your spam folder. If needed, <a href="#" (click)="resendEmail(); $event.preventDefault()" class="resend-link">click here</a> and we'll resend the email.
  </p>
</div>

@if (emailResent) {
  <div class="message-body">
    <p class="success-text">Email sent successfully!</p>
  </div>
}

@if (error) {
  <div >
    <p class="error-text">{{ error }}</p>
  </div>
}

<div class="help-section">
  <p class="help-text">
    Having issues or need help? Contact us at
    <a href="https://support.utest.com/csp" class="help-link" target="_blank">support.utest.com</a>
  </p>
</div>
</div>
